import { toDayJs } from '~/services/TimeService';

import { ConflictInfo, StopsellDateRange } from '~/types/stopsell';

export function detectConflict(newRange: StopsellDateRange, existing: StopsellDateRange): ConflictInfo | null {
  const ns = toDayJs(newRange.start);
  const ne = toDayJs(newRange.end);
  const es = toDayJs(existing.start);
  const ee = toDayJs(existing.end);

  if (ne.isBefore(es) || ns.isAfter(ee)) {
    return null;
  }

  const existingCoversNew = !es.isAfter(ns) && !ee.isBefore(ne);
  const newCoversExisting = !ns.isAfter(es) && !ne.isBefore(ee);

  if (existingCoversNew) {
    return { type: 'covered_by_existing', existingRange: existing };
  }

  if (newCoversExisting) {
    return { type: 'covers_existing', existingRange: existing };
  }

  return {
    type: 'partial_overlap',
    existingRange: existing,
    mergedRange: {
      start: ns.isBefore(es) ? newRange.start : existing.start,
      end: ne.isAfter(ee) ? newRange.end : existing.end,
    },
  };
}

export function findAllConflicts(
  newRange: StopsellDateRange,
  existingDates: Array<StopsellDateRange>,
): Array<ConflictInfo> {
  return existingDates.reduce<Array<ConflictInfo>>((acc, existing) => {
    const conflict = detectConflict(newRange, existing);
    if (conflict) {
      acc.push(conflict);
    }
    return acc;
  }, []);
}
